import React from 'react';
import { AfterSubmitFunc, FormTemplate, TextInput } from 'ui-builder';
import { TasksGroup, TasksGroupRequest } from 'nekst-api';
import { ColorPicker } from 'features/nekst-widgets';

export default function BaseTasksGroupAdminForm(
  props: {
    afterSubmitFunc?: AfterSubmitFunc,
    title?: string,
    submitFormFunc: (data: TasksGroupRequest) => Promise<TasksGroup>,
    initialData?: TasksGroup,
  }
) {
  return (
    <FormTemplate<TasksGroupRequest, TasksGroup>
      submitFormFunc={async (data) => {
        return await props.submitFormFunc(data);
      }}
      afterSubmitFunc={props.afterSubmitFunc}
      title={props.title}
      initialData={props.initialData || {
        color: '#000000'
      }}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
            minLength: {
              value: 3,
              message: 'Name must be at least 3 characters'
            },
            maxLength: {
              value: 30,
              message: 'Name must be no more than 30 characters'
            }
          }
        },
        color: {
          type: 'string',
          constraints: {
            required: true,
            minLength: {
              value: 7,
              message: 'Color must be a hex color code'
            },
            maxLength: {
              value: 7,
              message: 'Color must be a hex color code'
            }
          }
        }
      }}
    >
      <TextInput source="name" label="Group Name" />
      <ColorPicker source="color" label="Color" />
    </FormTemplate>
  );
}
